export { getMyAssignmentList } from './assignment';
export { getCommentList } from './getCommentList';
export { like } from './like';
export { bindResource, bindResourceV1, getResourceList } from './resource';
export { saveComment } from './saveComment';
export {
    getUnreadDialogs,
    readDialog,
    setStatLogDialogs,
    getAglExpiryReminderPopup,
    markAglExpiryReminderPopupShown,
} from './achievement';

import { clickAd } from './clickAd';
import { docReadSpeedStatusReset, docReadSpeedStatusResetAsync } from './docReadSpeedStatusReset';
import { downloadFile } from './downloadFile';
import { getCommentVersion, getCommentVersionSync } from './getCommentVersion';
import { getCourseMyPointsRank, getCourseMyPointsRankSync } from './getCourseMyPointsRank';
import { getCoursePointsRank, getCoursePointsRankSync } from './getCoursePointsRank';
import { getCourseRankSharePic, getCourseRankSharePicSync } from './getCourseRankSharePic';
import { getHomeworkKeywords } from './getHomeworkKeywords';
import { getHomeworkGesture } from '../homework/getHomeworkGesture';
import { getHomeworkGestures } from '../homework/getHomeworkGestures';
import { getHomeworkList, getHomeworkListAsync } from './getHomeworkList';
import { getHomeworksStat } from './getHomeworksStat';
import { getImageTextList, getImageTextListAsync } from './getImageTextList';
import { getObjOuterStatus } from './getObjOuterStatus';
import { getTimelineCommentList } from './getTimelineCommentList';
import { getTimelineStatList } from './getTimelineStatList';
import { getTimelineStatUserList } from './getTimelineStatUserList';
import { getWeikeListenerInfo } from './getWeikeListenerInfo';
import {
    makeDocReadSpeedStatus,
    makeWeikeSpeedStatusOld,
    markWeikeStatus,
    makeDocReadSpeedStatusOld,
} from './makeDocReadSpeedStatus';
import { priseCreator, prise } from './priseCreator';
import { saveMultimedia } from './saveMultimedia';
import { makeCompletionStatus, sendBeanMakeCompletionStatus } from './setSessionCompletion';
import { updateMultimedia } from './updateMultimedia';
import { weikeCommentSubmit } from './weikeCommentSubmit';
import { weikeCommentSubmitNew } from './weikeCommentSubmitNew';
import { getConfig } from './config';
import { shieldSaveService,canReportService } from "./violation";


export {
    clickAd,
    docReadSpeedStatusReset,
    docReadSpeedStatusResetAsync,
    downloadFile,
    getCommentVersion,
    getCommentVersionSync,
    getCourseMyPointsRank,
    getCourseMyPointsRankSync,
    getCoursePointsRank,
    getCoursePointsRankSync,
    getCourseRankSharePic,
    getCourseRankSharePicSync,
    getHomeworkKeywords,
    getHomeworkGesture,
    getHomeworkGestures,
    getHomeworkList,
    getHomeworkListAsync,
    getHomeworksStat,
    getImageTextList,
    getImageTextListAsync,
    getObjOuterStatus,
    getTimelineCommentList,
    getTimelineStatList,
    getTimelineStatUserList,
    getWeikeListenerInfo,
    makeDocReadSpeedStatus,
    prise,
    priseCreator,
    saveMultimedia,
    makeCompletionStatus,
    makeWeikeSpeedStatusOld,
    markWeikeStatus,
    makeDocReadSpeedStatusOld,
    updateMultimedia,
    weikeCommentSubmit,
    weikeCommentSubmitNew,
    sendBeanMakeCompletionStatus,
	getConfig,
    shieldSaveService,
    canReportService
};
